
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locality",
      function () {
        return require("private-next-pages/locality.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locality"])
      });
    }
  